module.exports = __webpack_public_path__ + "static/media/b_1.a6bc0013.jpg";